import { ensureUnreachable } from 'src/utils/common_utils';

import { DialogCloseReason, DialogProps } from './types';

/**
 * Ensures the reason is a valid dialog close reason
 * @param reason - the reason to ensure
 * @returns the valid dialog close reason
 */
export function ensureDialogCloseReason(reason: string): DialogCloseReason {
  switch (reason) {
    case 'backdropClick':
    case 'closeButtonClick':
    case 'escapeKeyDown':
      return reason;
    default:
      ensureUnreachable(
        reason as never,
        `Invalid dialog close reason: ${reason}`,
      );
  }
}

/**
 * Returns ARIA props for the dialog based on the dialog ID
 * @param props.id - the id of the dialog
 * @returns the ARIA props for the dialog
 * @example
 * ```js
 * const ariaProps = getARIAProps({ id: 'dialog-1' });
 * // { content: 'dialog-1-content', title: 'dialog-1-title' }
 * ```
 */
export function getARIAProps({ id }: Pick<DialogProps, 'id'>) {
  return {
    content: `${id}-content`,
    title: `${id}-title`,
  } as const;
}
